<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Affiliate URL</h2>
      </div>

      <base-button
        outline
        class="px-3 py-1 mx-1"
        type="primary"
        @click="handleOpen"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add URL
        </span>
      </base-button>
    </div>
    <AffiliateUrlTable ref="dataload" />
    <b-modal
      header-bg-variant="primary text-white"
      class="custmodaltitle"
      id="add-url"
      title="Add URL"
      hide-footer
    >
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleCreate)">
          <div class="mb-4">
            <p class="input-title text-black">Page</p>
            <base-input name="Page" :rules="{ required: true }">
              <b-form-select
                v-model="page"
                placeholder="Select Page"
                required
                class="mr-4"
              >
                <b-form-select-option :value="null" disabled
                  >Select Page
                </b-form-select-option>
                <b-form-select-option
                  v-for="item in pageOptions"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.text }}
                </b-form-select-option>
              </b-form-select>
            </base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Category</p>
            <base-input name="Category" :rules="{ required: true }">
              <b-form-select v-model="category" required class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select Category
                </b-form-select-option>
                <b-form-select-option
                  v-for="item in options"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.text }}
                </b-form-select-option>
              </b-form-select>
            </base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Title</p>
            <base-input
              v-model="title"
              placeholder="Enter title"
              class="md:border-0 lg:border-0 custipshadow"
              name="Title"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Link</p>
            <base-input
              v-model="link"
              placeholder="Enter link (https://caregiversaathi.co.in/)"
              class="md:border-0 lg:border-0 custipshadow"
              name="Link"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="flex justify-center">
            <b-button
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
              >Save</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
  </b-card>
</template>

<script>
import AffiliateUrlTable from "./components/AffiliateUrlTable.vue";

export default {
  components: {
    AffiliateUrlTable,
  },
  data() {
    return {
      title: "",
      link: "",
      category: "",
      page: "",
      options: [
        { value: "Latest Research", text: "Latest Research" },
        { value: "Explore Resources", text: "Explore Resources" },
        {
          value: "Helpful Links and Collaborations",
          text: "Helpful Links and Collaborations",
        },
      ],
      pageOptions: [
        { value: "Cancer", text: "Cancer" },
        { value: "Palliative Care", text: "Palliative Care" },
        { value: "Dementia", text: "Dementia" },
        { value: "Neurological Disorders", text: "Neurological Disorders" },
      ],
    };
  },
  methods: {
    handleOpen() {
      this.title = "";
      this.link = "";
      this.category = "";
      this.page = "";
      this.$bvModal.show("add-url");
    },
    async handleCreate() {
      let payload = {
        page: this.page,
        category: this.category,
        title: this.title.trim(),
        link: this.link.trim(),
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("affiliate/createUrl", payload);
        this.$refs.dataload.dataload();
        this.reset();
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    reset() {
      this.$bvModal.hide("add-url");
      this.page = "";
      this.category = "";
      this.title = "";
      this.link = "";
    },
  },
};
</script>
<style>
.modal-title {
  color: white !important;
}
</style>
